import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useReactToPrint } from "react-to-print";

function CustomPrint() {
  const location = useLocation();
  const componentRef = useRef();
  const navigate = useNavigate();
  console.log(location);
  const { companyInfo } = useSelector((state) => state?.common);
  const logo = JSON.parse(companyInfo?.logo);
  const columns = [
    { label: "SINO" },
    { label: "Item Name" },
    { label: "Barcode" },
    { label: "Opening Stock" },
    { label: "Total Stock" },
    { label: "Cost" },
    { label: "Total Cost" },
    { label: "Price" },
    { label: "Tax%" },
    { label: "Tax Amnt" },
    { label: "Net Value" },
  ];
  const tabledata = location.state?.tabledata;
  const decimalCount = location.state?.decimalCount;
  const headerStyle = {
    p: 0,
    textAlign: "center",
    bgcolor: "#4527a0",
    color: "#FFF",
    fontSize: "10px",
  };
  const cellStyle = {
    p: 0,
    textAlign: "center",
    border: "1px solid black",
    fontSize: "10px",
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => {
      navigate(-2);
    },
  });

  useEffect(() => {
    handlePrint();
  }, [handlePrint]);

  return (
    <div ref={componentRef}>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Box px={2}>
          <Box
            component={"img"}
            sx={{ height: 140, width: 140 }}
            src={logo?.img}
          />
        </Box>
        <Box>
          <Typography variant="h2" fontWeight={"bold"}>
            Stock Report
          </Typography>
        </Box>
        <Box px={2}>
          <Stack>
            <Typography textAlign={"center"} variant="h3">
              {companyInfo?.Name}
            </Typography>
            <Typography
              textAlign={"center"}
              variant="h5"
            >{`${companyInfo?.Add1} ${companyInfo?.Add2}`}</Typography>
            <Typography textAlign={"center"} variant="h5">
              {companyInfo?.Ph}
            </Typography>
            <Typography textAlign={"center"} variant="h5">
              {companyInfo?.city_name}
            </Typography>
            <Typography textAlign={"center"} variant="h5">
              {companyInfo?.Place}
            </Typography>
            <Typography textAlign={"center"} variant="h5">
              {companyInfo?.EMail}
            </Typography>
          </Stack>
        </Box>
      </Stack>
      <TableContainer sx={{ mt: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              {columns?.map((head, idx) => {
                return <TableCell sx={headerStyle}>{head.label}</TableCell>;
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {tabledata?.map((data, idx) => {
              return (
                <TableRow key={idx}>
                  <TableCell sx={cellStyle}>{idx + 1}</TableCell>
                  <TableCell sx={cellStyle}>{data.name}</TableCell>
                  <TableCell sx={cellStyle}>{data.barcode}</TableCell>
                  <TableCell sx={cellStyle}>
                    {data.stk_main === "" || data.stk_main === null
                      ? 0
                      : data.stk_main?.toFixed(decimalCount)}
                  </TableCell>
                  <TableCell sx={cellStyle}>
                    {data.curr === "" || data.curr === null
                      ? 0
                      : data.curr?.toFixed(decimalCount)}
                  </TableCell>
                  <TableCell sx={cellStyle}>
                    {data.cost1 === "" || data.cost1 === null
                      ? 0
                      : data.cost1?.toFixed(decimalCount)}
                  </TableCell>
                  <TableCell sx={cellStyle}>
                    {data.net_cost === "" || data.net_cost === null
                      ? 0
                      : data.net_cost?.toFixed(decimalCount)}
                  </TableCell>
                  <TableCell sx={cellStyle}>
                    {data.mrp === "" || data.mrp === null
                      ? 0
                      : data.mrp?.toFixed(decimalCount)}
                  </TableCell>
                  <TableCell sx={cellStyle}>
                    {data.tax1 === "" || data.tax1 === null
                      ? 0
                      : data.tax1?.toFixed(decimalCount)}
                  </TableCell>
                  <TableCell sx={cellStyle}>
                    {data.taxamt === "" || data.taxamt === null
                      ? 0
                      : data.taxamt?.toFixed(decimalCount)}
                  </TableCell>
                  <TableCell sx={cellStyle}>
                    {data.nettot === "" || data.nettot === null
                      ? 0
                      : data.nettot?.toFixed(decimalCount)}
                  </TableCell>
                </TableRow>
              );
            })}

            {tabledata?.length > 0 && (
              <TableRow sx={{ bgcolor: "#f0f0f0" }}>
                <TableCell
                  colSpan={4}
                  sx={{ ...cellStyle, fontWeight: "bold" }}
                >
                  TOTAL:
                </TableCell>
                <TableCell sx={{ ...cellStyle, fontWeight: "bold" }}>
                  {tabledata
                    ?.reduce((sum, item) => sum + (item.curr || 0), 0)
                    ?.toFixed(decimalCount)}
                </TableCell>
                <TableCell sx={cellStyle}></TableCell>
                <TableCell sx={{ ...cellStyle, fontWeight: "bold" }}>
                  {tabledata
                    ?.reduce((sum, item) => sum + (item.net_cost || 0), 0)
                    ?.toFixed(decimalCount)}
                </TableCell>
                <TableCell sx={cellStyle}></TableCell>
                <TableCell sx={cellStyle}></TableCell>
                <TableCell sx={{ ...cellStyle, fontWeight: "bold" }}>
                  {tabledata
                    ?.reduce((sum, item) => sum + (item.taxamt || 0), 0)
                    ?.toFixed(decimalCount)}
                </TableCell>
                <TableCell sx={{ ...cellStyle, fontWeight: "bold" }}>
                  {tabledata
                    ?.reduce((sum, item) => sum + (item.nettot || 0), 0)
                    ?.toFixed(decimalCount)}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default CustomPrint;
